import { type FC } from "react";

import { getIconForPlaybookCategory } from "../../../../app-utils/playbook.js";
import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { TableCell } from "./core/TableCell.js";

const CategoryImageCell: FC<IAgGridCellProps> = (props) => {
  const icon = getIconForPlaybookCategory({
    imageName: props.value,
  });

  if (!props) {
    return null;
  }

  return (
    <TableCell style={{ textAlign: "center" }}>
      <img src={icon.large} style={{ borderRadius: 15, width: 30, height: 30 }} />
    </TableCell>
  );
};

export default CategoryImageCell;
